module.exports = __webpack_public_path__ + "img/banner.49b85f77.png";